import React from 'react';
import { CUSTOM_DOMAIN_ROUTES } from 'routes/_definition';
import { Redirect } from 'react-router-dom';

const ArtistCard: React.FC = () => <Redirect from={CUSTOM_DOMAIN_ROUTES.CARD} to={CUSTOM_DOMAIN_ROUTES.LINKS} />;

export default ArtistCard;
